export default __webpack_public_path__ + "static/media/032-keyhole.8c81d1cf.png";